import {
    Component,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    OnInit,
    OnChanges,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { CardStyle } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';

@Component({
    selector: 'playing-card',
    templateUrl: './playing-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./playing-card.component.scss'],
    standalone: false
})
export class PlayingCardComponent implements OnInit, OnChanges {
    @Input() cardId: string;
    @Input() toggledCard: boolean;
    @Input() timeToShow: boolean;
    @Input() isClient: boolean;
    @Input() communityCards: boolean;
    @Input() isGProgress: boolean;
    @Input() isRevealed: boolean;
    @Input() rabbitCard = false;
    @Output() toggleCard: EventEmitter<string> = new EventEmitter();

    flip = false;
    cardStyle$: Observable<CardStyle>;

    constructor(
        private ref: ChangeDetectorRef,
        private gameThemeSettings: GameThemeSettingsDispatcher
    ) { }

    ngOnInit(): void {
        this.cardStyle$ = this.gameThemeSettings.getGameThemeSettingsState()
            .pipe(
                map(gameData => gameData.cardStyle),
            );
    }

    ngOnChanges(): void {
        if (this.cardId && this.communityCards && this.isGProgress && !this.rabbitCard) {
            this.flip = true;
            setTimeout(() => {
                this.flip = false;
                this.ref.markForCheck();
            }, 200);
        }

        // To add flip animation to rabbit cards uncomment this if

        // if (this.rabbitCard) {
        //     this.flip = true;
        //     setTimeout(() => {
        //         this.flip = false;
        //         this.ref.markForCheck();
        //     }, 200);
        // }
    }

    getCardSrc(cardId: string): string {
        return `assets/img/card/${cardId}.png`;
    }

    getCardStyle(cardId: string): string {
        return `background:url(assets/img/card/${cardId}.png)`;
    }

    getCardBackStyle(): string {
        return `background:url(assets/img/card/XX.png)`;
    }

    submitFoldToShow(cardId: string): void {
        this.toggleCard.emit(cardId);
    }

}
